import React, { Component } from 'react';

import ListaDeRequerimentos from './ListaDeRequerimentos';
import api from '@api';
import navigate from '@/utils/navigate';
import Dropdown from '@/Componentes/Dropdown';
import DateCalculator from '@/Componentes/DateCalculator';
import calculateDateDiff from '@/utils/calculate-date-diff';
import { Matricula, AlunoNome } from '@/Componentes';

export default class EmitirTCE extends Component {
	constructor() {
		super();

		this.state = {
			listaDeApolices: [],
			listaDeRequerimentos: [],
			tce: {
				apolice: {},
				jornada_estagio: {
					dias_da_semana: 'SEGUNDA_SEXTA',
					horario_inicio: '08:00',
					horario_final: '18:00',
				},
				vigencia: {},
			},
		};

		this.onChange = this.onChange.bind(this);
		this.onChangeSubAttribute = this.onChangeSubAttribute.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.carregaRelacaoDeRequerimentos();
	}

	componentDidMount() {
		this.carregaRelacaoDeApolices();
		this.carregaValoresIniciais();
	}

	criaTermoDeCompromisso(dados) {
		api.termosDeCompromisso.CriaTermoDeCompromisso(dados)
			.then(() => {
				navigate('/');
			})
			.catch((erro) => {
				console.log(erro);
			});
	}

	carregaRelacaoDeRequerimentos() {
		api.requerimentos.ListaRequerimentos()
			.then((listaDeRequerimentos) => {
				this.setState({ listaDeRequerimentos });
			});
	}

	carregaRelacaoDeApolices() {
		api.apolices.ListaApolices()
			.then((listaDeApolices) => {
				this.setState({ listaDeApolices });
			});
	}

	carregaValoresIniciais() {
		const provavelAssinatura = new Date();
		provavelAssinatura.setDate(provavelAssinatura.getDate() + 2);

		const incremento = provavelAssinatura.getDay() === 6 ? 2 : provavelAssinatura.getDay() === 0 ? 1 : 0;
		provavelAssinatura.setDate(provavelAssinatura.getDate() + incremento);
		const data_da_assinatura = provavelAssinatura.toISOString().substring(0, 10);

		provavelAssinatura.setDate(provavelAssinatura.getDate() + 1);
		const inicio = provavelAssinatura.toISOString().substring(0, 10);

		provavelAssinatura.setDate(provavelAssinatura.getDate() + 60);

		this.setState(prevState => ({
			tce: {
				...prevState.tce,
				data_da_assinatura,
				vigencia: {
					inicio,
				},
			},
		}));
	}

	onSubmit(e) {
		e.preventDefault();

		const { tce } = this.state;
		this.criaTermoDeCompromisso(tce);
	}

	onChange(e) {
		const { name, value } = e.target;

		this.setState(prevState => ({
			tce: {
				...prevState.tce,
				[name]: value,
			},
		}));
	}

	onChangeSubAttribute(attribute, e) {
		const { name, value } = e.target;

		const target = {
			name: attribute,
			value: {
				...this.state.tce[attribute],
				[name]: value,
			},
		};

		this.onChange({ target });
	}

	render() {
		const { tce, listaDeApolices, listaDeRequerimentos } = this.state;
		const requerimento =
			tce.requerimento !== undefined
				? listaDeRequerimentos.filter(requerimento => requerimento.id === tce.requerimento.id)[0]
				: {};

		if (tce.requerimento === undefined) {
			return (
				<ListaDeRequerimentos
					listaDeRequerimentos={listaDeRequerimentos}
					onSelect={(requerimento) => this.setState(prevState => ({ tce: { ...prevState.tce, requerimento: { id: requerimento.id }, carga_horaria_minima: requerimento.aluno.curso.carga_horaria_minima } }))}
				/>
			);
		}

		return (
			<div className="mx-4">

				<form className="d-flex flex-column" onSubmit={this.onSubmit}>
					<h4 className="mb-3 text-dark">
						Novo Termo de Compromisso
					</h4>

					<h5 className='bg-light text-center p-2 border-top'>Dados cadastrais</h5>

					<div className='mb-3 row'>
						<CustomLabel
							className="mb-2 col-12 d-flex"
							title="Aluno(a)"
							value={<AlunoNome value={requerimento.aluno.nome} />}
						/>
						<CustomLabel className="mb-2 col-3" title="CPF" value={requerimento.aluno.cpf} />
						<CustomLabel
							className="mb-2 col-3 d-flex"
							title="Matrícula"
							value={<Matricula value={requerimento.aluno.matricula} />}
						/>
						<CustomLabel className="mb-2 col-2" title="Telefone" value={requerimento.aluno.telefone} />
						<CustomLabel className="mb-2 col-4" title="Email" value={requerimento.aluno.email} />
						{/* <hr className='my-3' /> */}

						<CustomLabel className="mb-2 col-6" title="Curso" value={requerimento.aluno.curso.nome} />
						<CustomLabel className="mb-2 col-6" title="Orientador(a)" value={requerimento.orientador.nome} />
						{/* <hr className='my-3' /> */}

						<CustomLabel className="mb-2 col-6" title="Concedente" value={requerimento.local_do_estagio.concedente.nome} />
						<CustomLabel className="mb-2 col-6" title="Supervisor(a)" value={requerimento.supervisor.nome} />
						<CustomLabel className="mb-2 col-6" title="Campo de Estágio" value={requerimento.local_do_estagio.nome} />
						{/* <hr className='mt-3 mb-0' /> */}
					</div>

					<h5 className='bg-light text-center p-2 border-top'>Parâmetros do contrato</h5>

					<div className='row mb-3'>
						<div className="col-lg-4 col-md-3 col-sm-6 col-6">
							<label className='form-label' htmlFor="apolice">Apolice do Seguro de acidentes pessoais</label>
							<select
								className="form-select"
								id="id"
								name="id"
								value={tce.apolice.id}
								onChange={(e) => this.onChangeSubAttribute('apolice', e)}
								required
							>
								<option key='' value=''>Selecione uma apolice</option>
								{listaDeApolices.map(apolice =>
									<option key={apolice.id} value={apolice.id}>{apolice.empresa}</option>
								)}
							</select>
						</div>

						<div className="form-group col-lg-2 col-md-3 col-sm-6 col-6">
							<label className='form-label' htmlFor="carga_horaria_minima">C/H Min.</label>
							<input className="form-control" id="carga_horaria_minima" name="carga_horaria_minima" type="number" value={tce.carga_horaria_minima} onChange={this.onChange} required />
						</div>

						<div className="col-lg-2 col-md-3 col-sm-6 col-6">
							<label className='form-label' htmlFor="inicio" >Inicio da Vigência</label>
							<input className="form-control" id="inicio" name="inicio" type="date" value={tce.vigencia?.inicio || ''} onChange={(e) => this.onChangeSubAttribute('vigencia', e)} required />
						</div>

						<div className="col-md-1 col-12 flex flex-column align-self-end">
							<Dropdown>
								<Dropdown.Toggle className='btn btn-outline-primary w-100'>
									<span className='fas fa-calculator' />
									<span className='ms-2 fas fa-chevron-right' />
								</Dropdown.Toggle>

								<Dropdown.Menu className='bg-dark text-light'>
									<DateCalculator
										startDate={tce.vigencia.inicio}
										totalHours={tce.carga_horaria_minima}
										setDateField={(value) => this.onChangeSubAttribute('vigencia', { target: { name: 'fim', value } })}
									/>
								</Dropdown.Menu>
							</Dropdown>
						</div>

						<div className="col-lg-2 col-md-3 col-sm-6 col-6">
							<label className='form-label' htmlFor="fim">Final da Vigência</label>
							<input className="form-control" id="fim" name="fim" type="date" value={tce.vigencia?.fim || ''} onChange={(e) => this.onChangeSubAttribute('vigencia', e)} required />
						</div>

						<div className="col-md-1 col-12 flex flex-column align-self-end">
							<label htmlFor="totalDays" className="form-label">n. dias</label>

							<input type="text" className="form-control" disabled
								value={calculateDateDiff(this.state.tce.vigencia.inicio + 'T00:00:00-03:00', this.state.tce.vigencia.fim + 'T23:59:59-03:00') || ''}
							/>
						</div>
					</div>

					<div className="row mb-3">
						<div className="col-lg-4 col-md-3 col-sm-6 col-6">
							<label className='form-label' htmlFor="dias_da_semana">Dias para estágio</label>
							<select
								className="form-select"
								id="dias_da_semana"
								name="dias_da_semana"
								value={tce.jornada_estagio.dias_da_semana}
								onChange={(e) => this.onChangeSubAttribute('jornada_estagio', e)}
							>
								<option key='SEGUNDA_SEXTA' value='SEGUNDA_SEXTA'>Segunda a Sexta-Feira</option>
								<option key='SEGUNDA_SABADO' value='SEGUNDA_SABADO'>Segunda a Sábado</option>
								<option key='DOMINGO_SABADO' value='DOMINGO_SABADO'>Todos os dias</option>
							</select>
						</div>

						<div className="col-lg-2 col-md-3 col-sm-6 col-6">
							<label className="form-label" htmlFor="horario_inicio">Início</label>
							<input className="form-control" id="horario_inicio" name="horario_inicio" type="time" min="06:00" max="22:00" value={tce.jornada_estagio.horario_inicio} onChange={(e) => this.onChangeSubAttribute('jornada_estagio', e)} required />
						</div>

						<div className="col-lg-2 col-md-3 col-sm-6 col-6">
							<label className="form-label" htmlFor="horario_final">Final</label>
							<input className="form-control" id="horario_final" name="horario_final" type="time" min="06:00" max="22:00" value={tce.jornada_estagio.horario_final} onChange={(e) => this.onChangeSubAttribute('jornada_estagio', e)} required />
						</div>

						<div className="col-lg-4 col-md-3 col-sm-6 col-6">
							<label className="form-label" htmlFor="data_da_assinatura">Data da assinatura do Termo de Compromisso</label>
							<input className="form-control" id="data_da_assinatura" name="data_da_assinatura" type="date" value={tce.data_da_assinatura} onChange={this.onChange} required />
						</div>
					</div>

					<div className="row my-2">
						<div className="ms-auto col-lg-3 col-md-4 col-sm-6 col-12">
							<input className="form-control btn btn-success" type="submit" value="Avançar" />
						</div>
					</div>

				</form>
			</div>
		);
	}
}

function CustomLabel({ title, value, ...props }) {
	return (
		<div className='mb-1' {...props}>
			<strong>{title}: </strong>
			{value}
		</div>
	);
}
